import { Injectable } from '@angular/core';

export interface Menu {
	state: string;
	name: string;
	type?: string;
	children?: Menu[];
}

const MENUITEMS = [
	{
		state: 'map',
		name: 'Mapa',
		type: 'link',
	},
	{
		state: 'chat',
		name: 'Czat',
		type: 'link',
	},
	{
		state: 'articles',
		name: 'Artykuły',
		type: 'link',
	},
	{
		state: 'trip-planner',
		name: 'Przejazdy',
		type: 'link',
	},
	{
		state: 'blog',
		name: 'Na żywo ',
		type: 'link',
	},
	{
		state: 'about-app',
		name: 'O aplikacji',
		type: 'link',
	},
	{
		state: 'partners',
		name: 'Partnerzy',
		type: 'link',
	},
	{
		state: 'home',
		name: 'Sklep',
		type: 'reroute',
		link: 'https://trekmondo.pl'
	},
	/*
	{
	  state: 'listing',
	  name: 'Listing',
	  type: 'sub',
	  children: [
		{
		   state: 'list',
		   name: 'List Layout',
		   type: 'sub',
		   children: [
			  {state: 'with-sidebar', name: 'With Sidebar', type: 'link'},
			  {state: 'full-width', name: 'Full Width', type: 'link'},
			  {state: 'full-width-map', name: 'Full Width + Map', type: 'link'}
			]
		},
		{
		   state: 'grid',
		   name: 'Grid Layout',
		   type: 'sub',
		   children: [
			  {state: 'with-sidebar', name: 'With Sidebar', type: 'link'},
			  {state: 'full-width', name: 'Full Width', type: 'link'},
			  {state: 'full-width-map', name: 'Full Width + Map', type: 'link'}
			]
		},
		{
		   state: 'half-map',
		   name: 'Half Screen Map',
		   type: 'sub',
		   children: [
			  {state: 'list', name: 'Layout 1', type: 'link'},
			  {state: 'grid', name: 'Layout 2', type: 'link'}
			]
		},
		{
		   state: 'detail',
		   name: 'Detail',
		   type: 'sub',
		   children: [
			  {state: 'version1', name: 'Version1', type: 'link'},
			  {state: 'version2', name: 'Version2', type: 'link'}
			]
		},
	  ]
	},
	{
	  state: 'admin',
	  name: 'User Panel',
	  type: 'sub',
	  children: [
		{state: 'dashboard', name: 'Dashboard', type: 'link'},
		{state: 'messages', name: 'Messages', type: 'link'},
		{state: 'bookings', name: 'Bookings', type: 'link'},
		{state: 'reviews', name: 'Reviews', type: 'link'},
		{state: 'bookmarks', name: 'Bookmarks', type: 'link'},
		{state: 'list', name: 'My Listing', type: 'link'},
		{state: 'add-list', name: 'Add List', type: 'link'},
		{state: 'profile', name: 'Profile', type: 'link'}
	  ]
	},
	 {
		state: 'session',
		name: 'Session',
		type: 'sub',
		children: [
		   {state: 'login', name: 'Login', type: 'link'},
		   {state: 'signup', name: 'Register', type: 'link'},
		   {state: 'forgot-password', name: 'Forgot Password', type: 'link'},
		   {state: 'coming-soon', name: 'Coming Soon', type: 'link'}
		]
	 }*/
];

@Injectable()
export class MenuItems {
	getAll() {
		return MENUITEMS;
	}
}
